import './PlayerHand.css';

import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import Card from "../../../card/Card";
import {useActions} from "../../../../hooks/useActions";
import {CanBePlayedCard} from "../../../../services/CanBePlayedCard";
import {useDrag} from "react-dnd";
import {useState} from "react";


function PlayerHandCard({card, handKey}) {

    const {showPlayUnitHover} = useTypedSelector(state => state.animation);
    const {tutorial} = useTypedSelector(state => state.auth);
    const {
        phase,
        playerFire,
        playerPow,
        playerDiamond,
        playerHand,
        playerTable,
        cpuTable,
        isPlaySpellDrag,
        playerMulligan
    } = useTypedSelector(state => state.game);
    const {
        playCard,
        setPlayedCard,
        setPhase,
        endTurn,
        setPlayerHand,
        setTutorial,
        setIsPlaySpellDrag,
        setShowPlayUnitHover
    } = useActions();
    const [showParentCard, setShowParentCard] = useState(true);

    let targetClasses = '';
    let canBePlayed = false;

    if (phase === 'play_card') {
        canBePlayed = CanBePlayedCard(card, playerFire, playerPow, playerDiamond, playerTable, cpuTable, tutorial, handKey);

        if (canBePlayed && playerMulligan) {
            targetClasses += ' animateCardBoxShadow';
        }
    }

    if (phase === 'discard_card') {
        targetClasses += ' animateCardBoxShadowDiscard';
    }

    const checkTargetWhenPlayCard = function () {
        if (card.type_card === 'unit') {
            setPlayedCard({card: card, handKey: handKey, target: null});
            setPhase('select_unit_target');
        }

        if (card.type_card === 'spell') {
            if (card.ability.need_select_target === 1) {
                setPlayedCard({card: card, handKey: handKey, target: null});
                setPhase('select_spell_target');

            } else {
                setPhase('play_card_progress');
                playCard({card: null, handKey: handKey, target: null});
            }
        }

        delete playerHand[handKey];
        setPlayerHand(playerHand);

        // Tutorial
        if (tutorial.step === 'PlaySpellCard70') {
            tutorial.step = 'SpellTarget75';
            setTutorial(tutorial);
        }
        //
    }

    const stopDrag = () => {
        if (isPlaySpellDrag === true) {
            setIsPlaySpellDrag(false);
        }
        if (phase !== 'play_unit' && phase !== 'select_spell_target' ) {
            if (showParentCard === false) {
                setShowParentCard(true);
            }
            if (phase !== 'play_card' && phase !== 'end_game') {
                setPhase('play_card');
            }
        }
    }

    const [{isDragging}, dragRef] = useDrag({
        type: 'card_' + card.type_card,
        item: {handKey: handKey, card: card},
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        }),
        end: (item, monitor) => {
            for (let i = 0; i < 5; i++) {
                showPlayUnitHover[i] = false;
            }

            setShowPlayUnitHover(showPlayUnitHover);
        }
    })

    let disableClass = '';
    if (!showParentCard) {
        disableClass = ' cardWrapperDisable';
    }
    if (isDragging) {
        if (showParentCard === true) {
            setShowParentCard(false);
        }
        if (canBePlayed) {
            if (card.type_card === 'unit') {
                if (phase !== 'select_unit_target') {
                    setPhase('select_unit_target');
                }
            }
            if (card.type_card === 'spell') {
                if (isPlaySpellDrag !== true) {
                    setIsPlaySpellDrag(true);
                }
            }
        }
    }

    if (!isDragging && !showParentCard) {
        stopDrag();
    }
    let realDragRef: any = dragRef;
    if (!canBePlayed) {
        realDragRef = null;
    }

   /* if(!isMobile && config.isNutaku){
        realDragRef = null;
    } */

    if(tutorial.isActive && tutorial.step === 'SelectAttack60'){
        canBePlayed = false;
        disableClass += ' cardWrapperTutorial ';
        targetClasses = '';
    }


    return (
            <div className={'cardWrapper' + disableClass} ref={realDragRef} onClick={() => {
                if (canBePlayed) {
                    checkTargetWhenPlayCard();
                }
                if (phase === 'discard_card') {
                    endTurn(handKey);
                }
            }}>
                <Card card={card} isSmall={true} isHand={true} targetClasses={targetClasses}/>
            </div>
)
    ;
}

export default PlayerHandCard;
